import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Input from '../../general/Input/Input';
import Button from '../../general/Button/Button';
import './LoginRegisterReset.css';  // Importando o CSS comum
import axios from "axios";
import Alert from '../../intern/Alert/Alert';


const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [errors, setErrors] = useState({});
    const navigate = useNavigate();
    const location = useLocation();
    const messageIncoming = location.state?.message || null;
    const apiUrl = process.env.REACT_APP_API_URL;
    const [alert, setAlert] = useState({ visible: false, type: '', message: '' });

    const showAlert = (type, message) => {
        setAlert({ visible: true, type, message });
        setTimeout(() => setAlert({ visible: false, type: '', message: '' }), 3000);
    };

    useEffect(() => {
        if (messageIncoming) { setAlert({ visible: true, type: 'info', message: messageIncoming }) };
    }, [messageIncoming]);

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post(
                `${apiUrl}/auth/login`,
                { email, password },
                { withCredentials: false } // Não precisamos mais de cookies HTTP-only aqui
            );


            // Salva o token no localStorage
            if (response.data.data.token) {
                localStorage.setItem("authToken", response.data.data.token);
            }

            navigate("/dashboard");
        } catch (error) {
            if (error.response && error.response.data) {
                const status = error.response.status;
                const msg = error.response.data.message || "Erro ao logar";

                if (msg.toLowerCase().includes("user-not-found")) {
                    setErrors({ email: "E-mail inválido! Por favor, verificar e tentar novamente.", password: '', general: '' });
                } else if (msg.toLowerCase().includes("wrong-password")) {
                    setErrors({ email: '', password: "Senha incorreta! Por favor, verificar e tentar novamente.", general: '' });

                } else if (status === 403 && msg.toLowerCase().includes("aguarde aprovação")) {
                    setErrors({});
                    showAlert('info', "Seu cadastro está em análise. Aguarde aprovação.");
                } else {
                    setErrors({ general: msg });
                }
            } else {
                setErrors({ general: "Erro desconhecido. Tente novamente." });
            }
        }
    };

    return (
        <div className="containerMain">
            <div className="formContainer">
                <div className="textCenter">
                    <h1 className="heading">Bem-vindo de volta ao AnalyticsBeta!</h1>
                    <p className="subheading">Faça login para continuar.</p>
                </div>

                <Helmet>
                    <title>Login</title>
                </Helmet>

                {alert.visible && (
                    <Alert
                        type={alert.type}
                        message={alert.message}
                        onClose={() => setAlert({ visible: false, type: '', message: '' })}
                    />
                )}

                <form onSubmit={handleLogin}>
                    <div className="inputGroup">
                        <Input
                            type="email"
                            placeholder="example@example.com"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            error={errors.email}
                        />
                        {errors.email && <p className="errorText">{errors.email}</p>}

                        <Input
                            type="password"
                            placeholder="*******"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            error={errors.password}
                        />
                        {errors.password && <p className="errorText">{errors.password}</p>}
                    </div>
                    {errors.general && <p className="errorText">{errors.general}</p>}


                    <Button type="submit" className='btn-margin btn-primary' variant="primary" fullWidth>
                        Acessar
                    </Button>


                    <div className="textCenter">
                        <Link to="/reset" className="linkReset">Você esqueceu a senha?</Link>
                    </div>

                    <hr className="divider" />  {/* Usando CSS comum agora */}

                    <div className="textCenter">
                        <p className="text-gray-600">
                            Não tem uma conta?
                            <Link to="/register" className="linkRegister">Cadastrar</Link>
                        </p>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default Login;
